import "./App.css";

import { Count } from "./components/Count/Count.jsx";
import { UserForm } from "./components/UserForm/UserForm.jsx";

function App() {
  return (
    <div className="App">
      <Count />
      <UserForm />
    </div>
  );
}

export default App;
